import { createBrowserRouter } from "react-router-dom";
import GeneralLayout from "./layout/GeneralLayout";
import FindWorkPage from "./pages/findWork";
import HomePage from "./pages/home";
import MarketplacePage from "./pages/marketplace";
import MarketplaceCategoryPage from "./pages/marketplaceCategory";
import BecomeSellerPage from "./pages/becomeSeller";
import GigPage from "./pages/gigPage";
import CheckoutPage from "./pages/checkout";
import TrustPage from "./pages/trust";
import SupportPage from "./pages/support";
import CommunityPage from "./pages/community";
import PrivacyPolicyPage from "./pages/privacyPolicy";
import TermsPage from "./pages/terms";
import AboutPage from "./pages/about";
import AffiliatePage from "./pages/affiliate";
import FreelancerDashboardPage from "./pages/freelancer/dashboard";
import FreelancerLayout from "./layout/FreelancerLayout";
import GigPostPage from "./pages/gigpost";
import FreelancerOrderPage from "./pages/freelancer/order";
import FreelancerGigsPage from "./pages/freelancer/gigs";
import FreelancerConnectPage from "./pages/freelancer/connect";
import FreelancerActiveOrderPage from "./pages/freelancer/order/active";
import FreelancerEarningsPage from "./pages/freelancer/earnings";
import FreelancerAnalyticsPage from "./pages/freelancer/analytics";
import FreelancerMessagesPage from "./pages/freelancer/messages";
import JobPostPage from "./pages/jobpost";

const routes = createBrowserRouter([
    {
        path:"",
        element: <GeneralLayout />,
        children:[
            {
                path:"",
                element:<HomePage />
            },
            {
                path:"/marketplace",
                element:<MarketplacePage />
            },
            {
                path:"/marketplace/:category",
                element:<MarketplaceCategoryPage />
            },
            {
                path:"/find-work",
                element:<FindWorkPage />
            },
            {
                path:"/become-seller",
                element:<BecomeSellerPage />
            },
            {
                path:"/gig/:id",
                element:<GigPage />
            },
            {
                path:"/checkout",
                element:<CheckoutPage />
            },
            {
                path:"/trust",
                element:<TrustPage />
            },
            {
                path:"/support",
                element:<SupportPage />
            },
            {
                path:"/community",
                element:<CommunityPage />
            },
            {
                path:"/privacy-policy",
                element:<PrivacyPolicyPage />
            },
            {
                path:"/terms",
                element:<TermsPage />
            },
            {
                path:"/about-us",
                element:<AboutPage />
            },
            {
                path:"/affiliate",
                element:<AffiliatePage />
            },
            {
                path:"/job/post",
                element:<JobPostPage />
            },
            {
                path:"/seller",
                element:<FreelancerDashboardPage />
            },
        ]
    },
    {
        path:"freelancer",
        element:<FreelancerLayout />,
        children:[
            {
                path:"dashboard",
                element:<FreelancerDashboardPage />
            },
            {
                path:"messages",
                element:<FreelancerMessagesPage />
            },
            {
                path:"order",
                element:<FreelancerOrderPage />
            },
            {
                path:"gigs",
                element:<FreelancerGigsPage />
            },
            {
                path:"analytics",
                element:<FreelancerAnalyticsPage />
            },
            {
                path:"earnings",
                element:<FreelancerEarningsPage />
            },
            {
                path:"active-order",
                element:<FreelancerActiveOrderPage />
            },
            {
                path:"connects",
                element:<FreelancerConnectPage />
            },
            {
                path:"gig/create",
                element:<GigPostPage />
            },
        ]
    }
])

export default routes;